export enum ButtonColorType {
  '#00AAEF',
  '#000000'
}
